import React, { useEffect, useRef, useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import {
  delete_icon,
  dummyimage,
  edit_icon,
  Search_icon,
  view_icon,
} from "../../assets/img";
import { Table } from "../../components/Table/Table";
import DateRange from "../../components/DateRange/DateRange";
import Topbar from "../../components/Topbar/Topbar";
import PropertyReqFileds from "../../components/Property/PropertyReqFileds";
import Accepted from "../../components/Wallet/Accepted";
import Rejected from "../../components/Wallet/Rejected";
import Requested from "../../components/Wallet/Requested";
import RequestedReview from "../../components/Review/RequestedReview";
import ActivateReview from "../../components/Review/ActivateReview";
import DeactivateReview from "../../components/Review/DeactivateReview";
import MultiUser from "../../components/Coupon/MultiUser";
import SingleUser from "../../components/Coupon/SingleUser";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { URLS } from "../../Services/Constant";
import { deletes, get, post } from "../../Services/ApiHandler";
import { checkPermission } from "../redux/api/PermissionManager";

const COUPON_TYPES = {
  MULTI_USER: "Mutliuser",
  SINGLE_USER: "Singleuser",
};

const LOCATION_TYPES = {
  STATE: 2,
  CITY: 3,
  AREA: 4,
};

const Coupon = () => {
  // const paths = pathname?.replace("/", "");

  const { paginationData, setpaginationData } = useGlobalContext();
  const location = useLocation();
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const [type, setType] = useState(location.state?.type);

  // let type = location.state?.type;
  const path = location.pathname?.replace("/", "");
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);

  // State Management
  // const [page, setPage] = useState(1);
  console.log("type", type);
  const [activeStatus, setActiveStatus] = useState(
    paginationData?.[path]?.tab ?? "Mutliuser"
  );
  const [pagination, setPagination] = useState("");
  const [count, setCount] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  console.log("paginationData?.[path]?.tab", paginationData?.[path]?.tab);

  // Filter State
  const [selectedFilter, setSelectedFilter] = useState({
    from_date: "",
    to_date: "",
    type: "",
    service: "",
    state: [],
    city: "",
    user_id: "",
    search: "",
  });

  // Dropdown States
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedServices, setSelectedServices] = useState(null);
  const [locationList, setLocationsList] = useState({
    states: [],
    cities: [],
    areas: [],
  });
  const [subTabs, setsubTabs] = useState(
    paginationData?.[path]?.tab ?? "Mutliuser"
  );

  useEffect(() => {
    setpaginationData((prev) => ({
      ...prev,
      [path]: { ...prev?.[path], tab: subTabs },
    }));
  }, [subTabs]);
  // Fetch locations list
  const getLocationsList = useCallback(async (locationType, parent_id) => {
    try {
      const url = `${URLS.LOCATION}?type=${locationType}${parent_id ? "&parent_id=" + parent_id : ""
        }`;
      const res = await get(url);

      if (res?.status === "success") {
        const modifiedList = res.data.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        switch (locationType) {
          case LOCATION_TYPES.STATE:
            setLocationsList((prev) => ({ ...prev, states: modifiedList }));
            break;
          case LOCATION_TYPES.CITY:
            setLocationsList((prev) => ({ ...prev, cities: modifiedList }));
            break;
          case LOCATION_TYPES.AREA:
            setLocationsList((prev) => ({ ...prev, areas: modifiedList }));
            break;
          default:
            break;
        }
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
    }
  }, []);

  // Fetch user list for dropdown
  const getUserIdList = useCallback(async () => {
    try {
      const res = await get(URLS.USERLIST_DROPDOWN);

      if (res?.status === "success") {
        const result = res.data.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        setSelectedUser(result);
      }
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  }, []);

  // Fetch services list for dropdown
  const getServicesList = useCallback(async () => {
    try {
      const res = await get(URLS.SERVICESLIST_DROPDOWN);

      if (res?.status === "success") {
        const result = res.data.map((item) => ({
          label: item.display_name,
          value: item.id,
        }));
        setSelectedServices(result);
      }
    } catch (error) {
      console.error("Error fetching services list:", error);
    }
  }, []);

  // Initialize dropdowns
  useEffect(() => {
    getLocationsList(LOCATION_TYPES.STATE);
    getUserIdList();
    getServicesList();
  }, [getLocationsList, getUserIdList, getServicesList]);

  // Fetch transactions/coupons list
  const getList = useCallback(
    async (pageNumber = 1) => {
      try {
        setLoading(true);
        const { from_date, to_date, service, state, city, user_id, search } =
          selectedFilter;
        const payload = new FormData();
        if (search) {
          payload.append("search", search);
        }
        if (from_date && to_date) {
          payload.append("from_date", from_date);
          payload.append("to_date", to_date);
        }
        if (service) {
          payload.append("service", service.value);
        }
        if (state) {
          payload.append("state", [state.value]);
        }
        if (city) {
          payload.append("city", city.value);
        }
        if (user_id) {
          payload.append("user_id", user_id.value);
        }

        const url =
          activeStatus === COUPON_TYPES.MULTI_USER
            ? `${URLS.GET_MULTIPLEUSER}/?page=${pageNumber}`
            : `${URLS.GET_SINGLEUSER}/?page=${pageNumber}`;

        const res = await post(url, payload);

        if (res?.status === "success") {
          setCount(res.count);
          setPagination({
            current_page: pageNumber,
            last_page: res.total_pages,
          });
          setTransactions(res.data || []);
        }
      } catch (error) {
        console.error("Error fetching transactions:", error);
        setTransactions([]);
      } finally {
        setLoading(false);
      }
    },
    [selectedFilter, activeStatus]
  );

  // Update pagination global state and fetch data
  console.log("page", page);
  useEffect(() => {
    getList(page);
    setpaginationData((prev) => ({
      ...prev,
      [path]: { ...prev?.[path], page: page, search: selectedFilter.search },
    }));
  }, [
    selectedFilter,
    activeStatus,
    page,
    path,
    getList,
    setpaginationData,
    type,
  ]);

  // Handle filter changes
  const handleChangeFilter = useCallback((name, val) => {
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
    setPage(1); // Reset to first page on filter change
  }, []);

  // Handle state change - reset city when state changes
  const handleStateChange = useCallback(
    (val) => {
      handleChangeFilter("state", val);
      setSelectedFilter((prev) => ({ ...prev, city: null }));
      setLocationsList((prev) => ({ ...prev, cities: [] }));
      if (val) {
        getLocationsList(LOCATION_TYPES.CITY, val.value);
      }
    },
    [handleChangeFilter, getLocationsList]
  );

  // Handle coupon status change
  const handleCouponStatusChange = useCallback(
    async (couponId) => {
      try {
        const url = `${URLS.COUPON_DEACTIVES}${couponId}/status/`;
        const res = await post(url);

        if (res?.status === "success") {
          getList(page);
        }
      } catch (error) {
        console.error("Error updating coupon status:", error);
      }
    },
    [page, getList]
  );

  // Handle add new coupon
  const handleAddCoupon = useCallback(() => {
    const route =
      activeStatus === COUPON_TYPES.MULTI_USER
        ? "/couponadd"
        : "/coupon-single-add";
    navigate(route, { state: { type: "add", tab: activeStatus } });
    setType(activeStatus);
  }, [activeStatus, navigate]);

  const toggleCouponType = useCallback((type) => {
    setsubTabs(type);
    setActiveStatus(type);

    setPage(1);
  }, []);
  const deleteRoom = async (couponId) => {
    try {
      const url = `${URLS.COUPON_DELETE}${couponId}/delete/`;
      const res = await deletes(url);

      if (res?.status === "success") {
        getList(page);
      }
    } catch (error) {
      console.error("Error updating coupon status:", error);
    }
  };

  return (
    <div>
      <Topbar header="Coupon" />

      <div className="d-flex ac-js mt-3 gap-4 flex-wrap">
        <h2 className="f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26">
          Total: {count}
        </h2>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 5,
          width: "99%",
        }}
      >
        {/* Coupon Type Tabs and Date Range */}
        <div
          className="scroll-hidden"
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row",
            gap: 5,
            width: "99%",
            overflowX: "auto",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
            <button
              style={{ width: 152 }}
              onClick={() => toggleCouponType(COUPON_TYPES.MULTI_USER)}
              className={`f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 request-btn ${activeStatus === COUPON_TYPES.MULTI_USER
                ? "active-btn1"
                : "inactive-btn"
                }`}
              aria-pressed={activeStatus === COUPON_TYPES.MULTI_USER}
            >
              Multiple User
            </button>

            <button
              style={{ width: 152 }}
              onClick={() => toggleCouponType(COUPON_TYPES.SINGLE_USER)}
              className={`f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 request-btn ${activeStatus === COUPON_TYPES.SINGLE_USER
                ? "active-btn1"
                : "inactive-btn"
                }`}
              aria-pressed={activeStatus === COUPON_TYPES.SINGLE_USER}
            >
              Single User
            </button>
          </div>

          <DateRange
            setFromDate={(date) => handleChangeFilter("from_date", date)}
            setToDate={(date) => handleChangeFilter("to_date", date)}
          />
        </div>

        {/* Filters */}
        <div className="d-flex ac-je mt-3 gap-1">
          <Select
            options={selectedServices}
            value={selectedServices?.find(
              (opt) => opt.value === selectedFilter.service?.value
            )}
            onChange={(val) => handleChangeFilter("service", val)}
            placeholder="Service Type"
            className="location-search"
            isClearable
            isLoading={!selectedServices}
          />

          <Select
            options={locationList.states}
            value={locationList.states.find(
              (opt) => opt.value === selectedFilter.state?.value
            )}
            onChange={handleStateChange}
            placeholder="State"
            className="location-search"
            isClearable
          />

          <Select
            options={locationList.cities}
            value={
              selectedFilter?.city
                ? locationList.cities.find(
                  (opt) => opt.value === selectedFilter.city?.value
                )
                : null
            }
            onChange={(val) => handleChangeFilter("city", val)}
            placeholder="City"
            className="location-search"
            isClearable
            isDisabled={!selectedFilter.state}
          />
          {activeStatus !== COUPON_TYPES.MULTI_USER ? (
            <Select
              options={selectedUser}
              value={selectedUser?.find(
                (opt) => opt.value === selectedFilter.user_id?.value
              )}
              onChange={(val) => handleChangeFilter("user_id", val)}
              placeholder="User ID"
              className="location-search"
              isClearable
              isLoading={!selectedUser}
            />
          ) : (
            <></>
          )}

          <div className="search-input d-flex ac gap-1">
            <input
              type="text"
              placeholder="Search Text"
              value={selectedFilter.search}
              onChange={(e) => handleChangeFilter("search", e.target.value)}
              style={{ border: "none", width: "150px" }}
            />
            <img src={Search_icon} className="search" alt="search-icon" />
          </div>

          {checkPermission("CAN-ADD-COUPON") && (
            <button
              style={{ width: 152 }}
              onClick={handleAddCoupon}
              className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn"
            >
              + Add New
            </button>
          )}
        </div>
      </div>

      {/* Conditional Rendering */}
      {activeStatus === COUPON_TYPES.MULTI_USER && (
        <MultiUser
          data={transactions}
          handleCoupon={handleCouponStatusChange}
          loading={loading}
          pagination={pagination}
          setPagination={setPagination}
          deleteCoupon={deleteRoom}
          page={page}
          setPage={setPage}
          type={type}
          setType={setType}
        />
      )}
      {activeStatus === COUPON_TYPES.SINGLE_USER && (
        <SingleUser
          // data={transactions}
          // handleCoupon={handleCouponStatusChange}
          // loading={loading}
          // deleteCoupon={deleteRoom}
          // setType={setType}
          data={transactions}
          handleCoupon={handleCouponStatusChange}
          loading={loading}
          pagination={pagination}
          setPagination={setPagination}
          deleteCoupon={deleteRoom}
          page={page}
          setPage={setPage}
          type={type}
          setType={setType}
        />
      )}
    </div>
  );
};

export default Coupon;
